import 'babel-polyfill';
import 'whatwg-fetch';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider }  from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import reducer from './reducers/index.js';
//import 'font-awesome-4.7.0/css/font-awesome.min.css';
import 'font-awesome-5.15.3/css/all.min.css';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

import HashRouter  from 'react-router-dom/HashRouter';
import { renderRoutes } from 'react-router-config';
import { createBrowserHistory } from 'history';
import routes from './routes.js';
import configureStore from './configurestore';

import { ConnectedRouter } from 'connected-react-router';

import { composeWithDevTools } from 'redux-devtools-extension';
const history = createBrowserHistory();
const store = configureStore(history);

// const store = createStore(reducer, composeWithDevTools(
// applyMiddleware(thunk)
// ));

const component = (
  <Provider store={store}>
    <ConnectedRouter history={history} >
      { renderRoutes(routes) }
    </ConnectedRouter>
  </Provider>
);

ReactDOM.render(component, document.getElementById('app'));



// WEBPACK FOOTER //
// ./src/client/client.js